// extracted by mini-css-extract-plugin
export var compactFilters = "_bi-4";
export var detailImage = "_bi-1";
export var dropdownContainer = "_bi-2";
export var imageContainer = "_bi-0";
export var selectedCard = "_bi-3";